import React, { useEffect, useState } from 'react';

/**
 * TrioMobilOzet: Trio Mobil denetiminin 3 slaytlık özeti (uzun sürüm /r/triomobil-denetim).
 * Route: /r/triomobil-ozet (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/triomobil-ozet/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~34KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function TrioMobilOzet() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./triomobilOzetHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Trio Mobil · Özet"
      srcDoc={html}
      style={fill}
    />
  );
}
